// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__r2F6n","head":"ProcedureTableInfo_head__1D90t"};